@if (downloadState$ | async; as downloadState) {
  <form [formGroup]="searchForm" (submit)="submitSearches(searchForm.value)">
    <div mat-dialog-title>
      <div class="flex flex-col gap-2">
        <h1 class="flex justify-between content-center items-center w-full flex-row">
          <span>Select searches</span>
          <button mat-icon-button mat-dialog-close type="button">
            <mat-icon>close</mat-icon>
          </button>
        </h1>
      </div>
      <mat-form-field class="w-full">
        <mat-label>Filter...</mat-label>
        <input matInput formControlName="searchTerm" />
      </mat-form-field>
    </div>
    @if (searches$ | async; as searchGroups) {
      <div mat-dialog-content>
        @if (isDownloadingSearches) {
          <div class="flex justify-center content-center items-center flex-col">
            <mat-spinner></mat-spinner>
          </div>
        }
        @let searchesList = searchGroups | keyvalue;
        @if (!isDownloadingSearches && !searchesList.length) {
          <div class="w-full text-center">No searches</div>
        }
        <mat-selection-list formControlName="searches">
          @for (searchGroup of searchesList; track searchGroup) {
            <div class="group-title flex justify-between content-center items-center flex-row">
              <p>{{ searchGroup.key }}</p>
              <div class="flex flex-row justify-end content-center items-center h-full">
                <p>({{ searchGroup.value.total }})</p>
                @if (!downloadState.loading) {
                  <button
                    mat-icon-button
                    type="button"
                    matTooltip="Download all in group"
                    matTooltipPosition="left"
                    (click)="downloadGroup(searchGroup.value.searches)"
                  >
                    <mat-icon> system_update_alt </mat-icon>
                  </button>
                }
                @if (downloadState.loading) {
                  <button mat-icon-button type="button" (click)="cancelDownloads($event)">
                    <mat-icon matTooltip="Cancel downloads" matTooltipPosition="left"> system_update_alt </mat-icon>
                  </button>
                }
              </div>
            </div>
            @for (search of searchGroup.value.searches | keyvalue; track search) {
              <mat-list-option checkboxPosition="before" [value]="search.value.batchId">
                <div class="flex justify-between content-center items-center flex-row">
                  <p class="flex-1">{{ search.key }}</p>
                  <div class="flex flex-row justify-end content-center items-center h-full">
                    <p>({{ search.value.total }})</p>
                    @let searchDownloadState = downloadState.downloads[search.value.batchId];
                    <button
                      mat-icon-button
                      type="button"
                      (click)="toggleDownload($event, search.value, search.key, searchDownloadState)"
                    >
                      <mat-icon
                        matTooltipPosition="left"
                        [class.loading]="isDownloading(searchDownloadState)"
                        [matTooltip]="isDownloading(searchDownloadState) ? 'Cancel download' : 'Download search'"
                      >
                        {{ getDownloadIcon(searchDownloadState) }}
                      </mat-icon>
                    </button>
                  </div>
                </div>
              </mat-list-option>
            }
          }
        </mat-selection-list>
      </div>
      <div mat-dialog-actions>
        <div class="flex flex-1 justify-end gap-2">
          <button mat-button type="button" (click)="toggleSelectAll({})">Deselect all</button>
          <button mat-button type="button" (click)="toggleSelectAll(searchGroups)">Select all</button>
          <button mat-raised-button color="primary" type="submit">Close</button>
        </div>
      </div>
    }
  </form>
}
